import Vue from 'vue'
import Router from 'vue-router'
import home from '../views/home'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'activity',
      component: home
    }
  ]
})

router.beforeEach((to, from, next) => {
  function IsIphone () {
    var userAgentInfo = navigator.userAgent
    var Agents = ['iPhone', 'iPad', 'iPod']
    var flag = true
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false
      }
    }
    return flag
  }
  if (!IsIphone()) {
    window.sessionStorage.setItem('ios', 'true')
    document.querySelector('body').style.width = document.documentElement.clientWidth + 'px'
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js